export default __webpack_public_path__ + "static/media/BOOK.9c0d726d.png";